
    import Vue from 'vue';
    import SchedulerService from '../services/scheduler.service';
    import {eventBus} from "@/services/event-bus";
    import Patient from "../models/patient";
    import PeriodPatientTherapiesList from "@/components/PeriodPatientTherpiesList.vue"


    export default Vue.extend({
        props: ['dialog', 'period'],
        computed: {
            model: {
                get(): any {
                    return this.period.patients;
                },
                set(val: any) {
                    this.$emit('input', val);
                }
            },
        },
        components: {
            periodPatientTherpiesList: PeriodPatientTherapiesList
        },
        data() {
            return {
                activator: null,
                attach: null,
                editing: null,
                index: -1,
                items: [] as Patient[],
                menu: false,
                x: 0,
                search: null,
                y: 0,
                patient: null,
            }
        },

        methods: {
            edit(index: any, item: any) {
                if (!this.editing) {
                    this.editing = item;
                    this.index = index
                } else {
                    this.editing = null;
                    this.index = -1
                }
            },
            filter(item: any, queryText: string, itemText: string) {
                if (item.header) return false;

                const hasValue = (val: string) => val != null ? val : '';

                const text = hasValue(itemText);
                const query = hasValue(queryText);

                return text.toString()
                    .toLowerCase()
                    .indexOf(query.toString().toLowerCase()) > -1
            },
            hideMenu() {
                this.$emit('hide-form');
            },
            toLabel(item: any): string {
                return `${item.name} ${item.surname}`;
            },
            allPatients() {
                return this.items.filter(it => this.period.patients !== undefined ? this.period.patients.findIndex((e: any) => it.name + " " + it.surname === e.name + " " + e.surname) === -1 : false)
            },
        },
        created() {
            SchedulerService.patientsForPeriod()
                .then(p => this.items = p.map((i: any) => new Patient(i)))
                .catch(e => eventBus.$emit('error', e.message))
        }
    });
